<template>
   <div class="uploadList">
      <div v-for="(item,index) in this.attachTypeList">
         <!--详情模式 都显示 -->
         <div class="uploadList_head" v-if="isEdit == false">
            <!-- 非二次提交附件 -->
            <template>
               <p style="width: 80%; text-align: left; text-indent: -1.5em; padding-left: 1.5em;">{{ item.text }}</p>
            </template>
         </div>
         <!--编辑模式，非主体结构阶段，都显示  -->
         <div class="uploadList_head" v-if="isEdit == true && stageName!='主体结构阶段' ">
            <template>
               <p style="width: 80%; text-align: left; text-indent: -1.5em; padding-left: 1.5em;">{{ item.text }}</p>
            </template>
            <div class="head_list" v-if="item.value == 1">
               <img src="../../../assets/img/main/download.png" style="width: 20px;height: 20px;">
               <p @click="_downloadFile(item.value)" style="width: 170px;">下载生成的PDF申请表==</p>
            </div>
            <template v-if="item.value == 1">
               <div class="head_list" v-if="canUpload">
                  <img src="../../../assets/img/banner/userlogin.png" style="width: 20px;height: 20px;">
                  <p @click="_uploadFile(item.value,item.attachFile)" style="width: 150px;">上传盖章后的PDF文件</p>
               </div>
            </template>
            <div class="head_list" v-if="canDown(item.value)">
               <img src="../../../assets/img/main/download.png" style="width: 20px;height: 20px;">
               <p @click="_downloadFile(item.value)">下载样表</p>
            </div>
            <template v-if="item.value != 1">
               <div class="head_list" v-if="canUpload">
                  <img src="../../../assets/img/banner/userlogin.png" style="width: 20px;height: 20px;">
                  <p @click="_uploadFile(item.value,item.attachFile)">点击上传</p>
               </div>
            </template>
         </div>
         <!--编辑模式，主体结构阶段 -->
         <div class="uploadList_head" v-if="isEdit == true && stageName=='主体结构阶段'">
            <!-- 非二次提交附件 -->
            <template v-if="item.value != vStageValue ">
               <p style="width: 80%; text-align: left; text-indent: -1.5em; padding-left: 1.5em;">{{ item.text }}</p>
            </template>
            <div class="head_list" v-if="item.value!=vStageValue && canDown(item.value)">
               <img src="../../../assets/img/main/download.png" style="width: 20px;height: 20px;">
               <p @click="_downloadFile(item.value)">下载样表</p>
            </div>
            <!-- 非二次提交附件 -->
            <template v-if="item.value!=vStageValue && canUpload">
               <div class="head_list">
                  <img src="../../../assets/img/banner/userlogin.png" style="width: 20px;height: 20px;">
                  <p @click="_uploadFile(item.value,item.attachFile)">点击上传</p>
               </div>
            </template>
            <!-- 二次提交附件   -->
            <template v-if="item.value ==vStageValue && isTwo">
               <p style="width: 80%; text-align: left; text-indent: -1.5em; padding-left: 1.5em;">{{ item.text }}</p>
            </template>
            <!-- 二次提交附件 -->
            <template v-if="item.value==vStageValue">
               <div class="head_list" v-if="canUploadTwo">
                  <img src="../../../assets/img/banner/userlogin.png" style="width: 20px;height: 20px;">
                  <p @click="_uploadFile(item.value,item.attachFile)">点击上传</p>
               </div>
            </template>
         </div>
         <!--已上传附件列表-->
         <div class="uploadList_bot">
            <p v-for="itemSub in item.attachFile">
               <a target="_blank" :href="itemSub.url">{{ itemSub.name }}</a>
            </p>
         </div>
      </div>
      <div class="uploadBtn" style="margin-bottom: 10px;" v-if="isEdit">
         <el-button type="primary" v-if="canSubmit" @click="_submitApply">提交</el-button>
      </div>
      <div>
         <upload-file-dialog ref="upload" @uploadCompleted="_uploadComplete"></upload-file-dialog>
         <submit-dialog ref="submitDialog"></submit-dialog>
      </div>
   </div>
</template>
<script>
   import ruiTool from "@/utils/ruiTool";
   import {getApplyAttachList, getApplyAttachListStage, getPrjUploadFiles} from '@/api/modules/paData'
   import uploadFileDialog from "@/views/greenEngineerApply/components/uploadFileDialog";
   import submitDialog from "@/views/greenEngineerApply/components/submitDialog";

   export default {
      props: ['stageName'],
      data() {
         return {
            form: {
               project_code: '',
               project_application_id: '',
               projectType: '',
               opMode: '',
            },
            //显示的附件类型
            attachTypeList: [],
            //当前点击附件类型
            clickAttachType: '',
            /*是否允许上传*/
            canUpload: false,
            canUploadTwo: false,
            /*是否允许提交*/
            canSubmit: false,
            /*可以下载附件的序号*/
            simpleFileList: ['4', '/', '5', '6', '7', '8', '/', '9', '10', '11', '12', '13', '/', '15', '16', '17', '18', '/', '22', '23', '24', '26'],
            /*推荐单位审批后，*/
            vStageValue: '14',
            stage: '',
            stageStatus: ''
         }
      },
      components: {uploadFileDialog, submitDialog},
      created() {
         this.form.projectType = localStorage.getItem('projectType');
      },
      computed: {
         isEdit() {
            return this.form.opMode == 'edit';
         },
         /*是否二次提交阶段*/
         isTwo() {
            this.stage = localStorage.getItem('stage');
            this.stageStatus = localStorage.getItem('stageStatus');
            return this.stage == '主体结构阶段' && this.stageStatus == 10;
         }
      },
      mounted() {
         //获取保存的传入参数
         this.form.project_application_id = localStorage.getItem("prjApplyCode")
         this.form.project_code = localStorage.getItem("prjCode");
         this.form.opMode = localStorage.getItem("opMode");

         //获取要上传的附件列表
         let param = {
            project_type: localStorage.getItem("projectType"),
            stageName: this.stageName
         }
         getApplyAttachListStage({
            data: param,
            success: (res) => {
               res.data.ddl.forEach((item, index) => {
                  this.attachTypeList.push({
                     value: item.value,
                     text: item.text,
                     attachFile: []
                  })
               })
            }
         })

         //修改模式 - 获取已上传的附件，并添加到对应附件类型中
         if (ruiTool.isNotNull(this.form.project_application_id)) {
            let param = {
               prjApplyId: this.form.project_application_id,
            }
            getPrjUploadFiles({
               data: param,
               success: (res) => {
                  //将返回的附件加入到对应的附件类型中
                  this.attachTypeList.forEach((type, index) => {
                     res.data.list.forEach((item, index) => {
                        if (type.value == item.type) {
                           type.attachFile.push({
                              name: item.data_name,
                              url: item.stored_path
                           });
                        }
                     })
                  })
               }
            })
         }

         /*根据阶段判断是否可以保存*/
         const stage = localStorage.getItem('stage');
         const stageStatus = localStorage.getItem('stageStatus');
         /*待提交*/
         if (this.stageName == stage && stageStatus == '0') {
            this.canSubmit = true;
            this.canUpload = true;
            this.canUploadTwo = false;
         }
         /*推荐退回 待提交*/
         if (this.stageName == stage && stageStatus == '8') {
            this.canSubmit = true;
            this.canUpload = true;
            this.canUploadTwo = false;
         }
         /*协会退回 待提交*/
         if (this.stageName == stage && stageStatus == '16') {
            this.canSubmit = true;
            this.canUpload = true;
            this.canUploadTwo = false;
         }
         /*待二次提交*/
         if (this.stageName == '主体结构阶段' && stageStatus == '10') {
            this.canSubmit = true;
            this.canUploadTwo = true;
         }
      },
      methods: {
         /*是否可以下载样表*/
         canDown(attachType) {
            console.info(attachType);
            return this.simpleFileList.includes(attachType);
         },
         /*项目提交*/
         _submitApply() {
            this.form.project_application_id = localStorage.getItem("prjApplyCode")
            if (ruiTool.isNull(this.form.project_application_id)) {
               this.$message.error('请先保存基本信息');
               return
            }
            this.$refs.submitDialog.showDialog(this.form.project_application_id);
         },
         /*点击上传附件*/
         _uploadFile(attachType, fileList) {
            this.form.project_application_id = localStorage.getItem("prjApplyCode")
            if (ruiTool.isNull(this.form.project_application_id)) {
               this.$message.error('请先保存基本信息');
               return
            }
            this.clickAttachType = attachType
            //显示对话框传入数据
            this.$refs['upload'].showDialog(this.form.project_application_id, attachType, '.pdf', fileList)
         },
         //下载pdf模板
         _downloadFile(attachType) {
            let map = new Map();
            map.set('4', "附件4-承诺书.docx");

            map.set('5', "附件5-绿色施工基本规定评价表.docx");
            map.set('6', "附件6-地基与基础自评表.docx");
            map.set('7', "附件7-绿色施工批次评价汇总表.docx");
            map.set('8', "附件8-绿色施工阶段评价汇总表.docx");

            map.set('9', "附件9-绿色施工基本规定评价表.docx");
            map.set('10', "附件10-主体结构五节一环保.docx");
            map.set('11', "附件11-绿色施工批次评价汇总表.docx");
            map.set('12', "附件12-绿色施工阶段评价汇总表.docx");
            map.set('13', "附件13-过程检查验收申请表.docx");

            map.set('15', "附件15-绿色施工基本规定评价表.docx");
            map.set('16', "附件16-装饰装修五节一环保.docx");
            map.set('17', "附件17-绿色施工批次评价汇总表.docx");
            map.set('18', "附件18-绿色施工阶段评价汇总表.docx");

            map.set('22', "附件22-技术创新创效与碳排放量化评价表.docx");
            map.set('23', "附件23-单位工程绿色施工评价总表.docx");
            map.set('24', "附件24-关键指标量化统计表.docx");
            map.set('26', "附件26-浙江省建筑业绿色施工示范工程.docx");

            var filePath = "/down/" + map.get(attachType)
            window.open(filePath);
         },
         //接受上传对话框回传数据
         _uploadComplete(e) {
            console.log('成功后返回的数据', e);
            const attachType = e.attachType;
            const uploadFileList = e.uploadFileList;
            this.attachTypeList.forEach((item, index) => {
               if (item.value == attachType) {
                  item.attachFile = [];
                  uploadFileList.forEach((itemSub, indexSub) => {
                     const v = {
                        name: itemSub.name,
                        url: itemSub.url
                     }
                     /*如果没有，则新增*/
                     if (item.attachFile.includes(v) == false)
                        item.attachFile.push(v);
                  })
               }
            })
            console.log('返回的数据3', this.attachTypeList);
         },
      }
   }
</script>

<style scoped>
   .uploadList {
      border: 1px solid #f0f0f0;
      width: 90%;
      margin-top: 30px;
      margin-left: 5%;
      margin-right: 5%;
      margin-bottom: 10px;
   }

   .uploadList_head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 40px 0 10px;
      line-height: 40px;
      font-size: 14px;
      border-bottom: 1px solid #f0f0f0;
   }

   .head_list {
      display: flex;
      align-items: center;
      cursor: pointer;
   }

   .uploadList_bot {
      padding-left: 1em;
      width: 80%;
      min-height: 30px;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      align-content: space-around;
      justify-content: flex-start;
   }

   .uploadList_bot p {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      color: #1890FF;
      text-decoration: underline;
      margin: 0 20px;
      cursor: pointer;
   }

   /* 上传样式 */
   .uploadContent {
      padding-top: 30px;
      padding-bottom: 30px;
   }

   .content_btn {
      display: flex;
      flex-flow: column;
      align-items: center;
      margin-bottom: 30px;
   }

   .content_btn p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FE2C54;
   }

   .content_btn button {
      width: 150px;
      margin-top: 40px;
      margin-left: 440px;
   }
</style>